export default __webpack_public_path__ + "static/media/carosel8.cb9fb8b4.jpg";